export default __webpack_public_path__ + "static/media/shoppingBag_img.7711b986.jpg";